import styled from 'styled-components';
import { verticalPadding, lineHeight } from 'js/components/common/Button/style';
import StepMessage from 'js/components/core/SteppedPage/StepMessage';

export default styled(StepMessage)`
  margin: ${verticalPadding + lineHeight / 2 + 1}rem auto 0;
`;
